
import * as ipxRuntime$NpYy0dCtjFf8y8SGE4bd5lVqpIiMoM91DlYaIoVoQrM from '/build/f995d4c0-f5f5-431f-8b50-c16aec6d2fc0/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$NpYy0dCtjFf8y8SGE4bd5lVqpIiMoM91DlYaIoVoQrM, defaults: {} }
}
        